const overwriteSalepify = () => {
  if (window.tlFreeGiftBlock) {
    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/clear",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe"
    ];

    function isShopifyCartURL(url) {
        if(url instanceof URL) url = url.href;
        if(typeof url == "object" && url.url) url = url.url;
        if (!url || url.includes("app=salepify")) return false;
        
        try {
            let path = url.split("/").pop();
                path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e)
            return false;
        }
    }

    function XHROverride() {
        if (!window.XMLHttpRequest) return;
    
        const originalOpen = XMLHttpRequest.prototype.open;
    
        XMLHttpRequest.prototype.open = function(method, url, async) {
            if (isShopifyCartURL(url)) {
                const oldReady = this.onreadystatechange;
    
                this.onreadystatechange = async function() {
                    if (this.readyState === 4) {
                        try {
                            if (window.tlFreeGiftBlock) {
                                await window.tlFreeGiftBlock.updateCartData();
    
                                const ruleAutoAdd = window.tlFreeGiftBlock.rules.filter(
                                    rule => window.tlFreeGiftBlock.getRemain(rule) > 0
                                );
    
                                const addedGift = await window.tlFreeGiftBlock.handleAutoAdd(
                                    ruleAutoAdd,
                                    window.tlFreeGiftBlock.displayRule &&
                                    window.tlFreeGiftBlock.getRemain(window.tlFreeGiftBlock.displayRule) > 0
                                        ? window.tlFreeGiftBlock.displayRule
                                        : null
                                );
    
                                if (addedGift) {
                                    if (!window.TLCustomEventGiftsBasic) {
                                        window.location.reload();
                                    } else if (window.TLCustomEventGiftsBasic === 1) {
                                        window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsBasicBlock-XHROverride"));
                                    }
                                }
                            }
                        } catch (err) {
                            console.error('[XHROverride] Error in gift logic:', err);
                        }
    
                        dispatchEvent(url.includes("add") ? "TLCARTGOAL:add" : "TLCARTGOAL:change", this.response);
                        dispatchEvent(url.includes("add") ? "TLFREEGIFT:add" : "TLFREEGIFT:change", this.response);
                        // Gọi lại onreadystatechange gốc nếu có
                        if (typeof oldReady === 'function') {
                            return oldReady.apply(this, arguments);
                        }
                    }
                };
            }
    
            return originalOpen.apply(this, arguments);
        };
    }

    XHROverride()
    clearInterval(intervalId);
  }
}
 
const intervalId = setInterval(overwriteSalepify, 50);
setTimeout(() => {
  clearInterval(intervalId);
}, 3000);	

window.TLCustomEventGiftsBasic = 1;
window.addEventListener('TLCustomEvent:FreeGiftsBasicBlock-XHROverride', (event) => {
  if (!window.location.href.includes("/cart") && window.ajaxCart) {
      window.ajaxCart.load()
  }else {
    window.location.reload();
  }
})

window.addEventListener('TLCustomEvent:FreeGiftsBasicBlock-handleClaimGifts', (event) => {
  if (!window.location.href.includes("/cart") && window.ajaxCart) {
      window.ajaxCart.load()
  }else {
    window.location.reload();
  }
})